import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import { RocketDryLocations } from 'Containers/RocketDry/RocketDryLocations/RocketDryLocations';

/**
 * Serialized (per-unit asset) replacement for the project RocketDry Equipment Log folder view,
 * shown when `serializedEquipment` is ON. Renders the same property → location → room tree the
 * legacy view uses (`RocketDryLocations`), but each room's slot renders the serialized per-room
 * equipment UI (`SerializedRoomEquipment`, wired in `RocketDryRooms`) instead of the legacy count
 * rows. It calls no legacy count endpoints (no TotalEquipment / add-count / delete-count modals).
 */
function SerializedRocketDryEquipment() {
  return (
    <div data-testid="serialized-rocketdry-equipment">
      <RocketDryLocations />
    </div>
  );
}

const SerializedRocketDryEquipmentMemo = memo(SerializedRocketDryEquipment, areEqual);

export { SerializedRocketDryEquipmentMemo as SerializedRocketDryEquipment };
